import { displayToast, sendAppsignalError } from "../modules/utils";

const promotionElement = document.querySelector("[data-js='promotion-shop']");

class PromotionShop {
  constructor(element) {
    this.element = element;

    this.fillCartButton = this.element.querySelector(".js-promotion-fill-cart");
    this.cartElement = this.element.querySelector(".js-promotion-cart");
    this.personElement = this.element.querySelector(".js-promotion-person");
    this.totalQvElement = document.querySelector(".js-promotion-shop-total-qv");
    this.totalCostElement = document.querySelector(".js-promotion-shop-total-cost");
    this.submitButton = document.querySelector(".js-promotion-submit");
    this.qvComponent = document.querySelector("[data-js-class='qv']");

    this.updateCartUrl = new URL(this.element.dataset.cartUrl, window.location.origin);
    this.updatePersonUrl = new URL(this.element.dataset.personUrl, window.location.origin);

    this.initialize();
  }

  initialize() {
    this.fillCartButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.updateCart();
    });

    this.initializeQuantityInputs();

    window.addEventListener("qv:level-reached", () => {
      this.submitButton.disabled = false;
    });

    window.addEventListener("qv:initial-level-reached", () => {
      this.submitButton.disabled = true;
    });
  }

  initializeQuantityInputs() {
    this.quantityInputs = this.element.querySelectorAll(".js-promotion-product-quantity");

    this.quantityInputs.forEach((quantityInput) => {
      quantityInput.addEventListener("change", () => {
        this.updatePersonAndCart();
      });
    });
  }

  updatePersonAndCart() {
    // We need to update the person element and the cart at the same time.
    const formData = new FormData();

    this.quantityInputs.forEach((quantityInput) => {
      formData.append(quantityInput.name, quantityInput.value);
    });

    this.personElement.classList.add("is-loading");

    fetch(this.updatePersonUrl, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then(async (response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json().catch(() => null);
        }

        throw new Error("Error updating person and cart");
      })
      .then((response) => {
        this.totalQvElement.innerHTML = response.totalQv;
        this.totalCostElement.innerHTML = response.totalCost;
        this.personElement.innerHTML = response.person;

        this.qvComponent.dispatchEvent(new CustomEvent("qv-update"));
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "PromotionShop", {
          response: this.response,
        });
      })
      .finally(() => {
        this.personElement.classList.remove("is-loading");
      });
  }

  updateCart() {
    const formData = new FormData();

    this.quantityInputs.forEach((quantityInput) => {
      formData.append(quantityInput.name, quantityInput.value);
    });

    this.personElement.classList.add("is-loading");
    this.cartElement.classList.add("is-loading");

    fetch(this.updateCartUrl, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then(async (response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json().catch(() => null);
        }

        throw new Error("Error updating cart");
      })
      .then((response) => {
        this.totalQvElement.innerHTML = response.totalQv;
        this.totalCostElement.innerHTML = response.totalCost;
        this.cartElement.innerHTML = response.cart;
        this.initializeQuantityInputs();

        this.personElement.innerHTML = response.person;
        this.qvComponent.dispatchEvent(new CustomEvent("qv-update"));
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "PromotionShop", {
          response: this.response,
        });
      })
      .finally(() => {
        this.personElement.classList.remove("is-loading");
        this.cartElement.classList.remove("is-loading");
      });
  }
}

if (promotionElement) {
  new PromotionShop(promotionElement);
}
